import { render, staticRenderFns } from "./TaskIssueDianFuStepTwo.vue?vue&type=template&id=57a1507e&"
import script from "./TaskIssueDianFuStepTwo.vue?vue&type=script&lang=js&"
export * from "./TaskIssueDianFuStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueDianFuStepTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports